module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-light-gray@3x-734e2c123fd1175a063b0dc0f2393841.png";